export function getFirstDateOfMonth(year: number, month: number) {
  return new Date(year, month, 1);
}

export function getLastDateOfMonth(year: number, month: number) {
  return new Date(year, month + 1, 0);
}
